module.exports = __webpack_public_path__ + "img/turnacom.fe3b632e.png";